import React from 'react';

import type { IIcon } from '../types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 30, className, onClick }, ref) {
  return (
    <svg ref={ref} viewBox='0 0 512 512' onClick={onClick} width={size} height={size} className={className}>
      <path fill='#E2E5E7' d='M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z' />
      <path fill='#B0B7BD' d='M384,128h96L352,0v96C352,113.6,366.4,128,384,128z' />
      <polygon fill='#CAD1D8' points='480,224 384,128 480,128 ' />
      <path fill='#09602C' d='M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z' />
      <g>
        <path
          fill='#FFFFFF'
          d='M81.7,312.1v20.3h32.6c4.6,0,9.2,4.6,9.2,9.1c0,4.2-4.6,7.7-9.2,7.7H81.7v26.9c0,4.5-3.2,7.9-7.7,7.9 c-5.6,0-9.1-3.4-9.1-7.9v-72.7c0-4.6,3.5-7.9,9.1-7.9h44.9c5.6,0,9,3.3,9,7.9c0,4.1-3.3,8.7-9,8.7L81.7,312.1L81.7,312.1z'
        />
        <path
          fill='#FFFFFF'
          d='M143.4,303.2c0-4.2,3.6-7.8,8.1-7.8c4.1,0,7.6,3.6,7.6,7.8v64.1h34.8c12.5,0,12.8,16.8,0,16.8h-42.3 c-4.5,0-8.1-3.2-8.1-7.8L143.4,303.2L143.4,303.2L143.4,303.2z'
        />
        <path
          fill='#FFFFFF'
          d='M219.8,384c-4.1-2.3-6.7-6.9-4.1-12.3l36.7-71.7c3.5-6.8,12.7-7,15.9,0l36.1,71.7c5.2,10-10.2,17.9-14.8,7.9 l-5.6-11.2h-47.2l-5.5,11.3C229.1,384,224.4,384.9,219.8,384z M274.8,351.5l-14.4-31.6l-15.7,31.6H274.8z'
        />
      </g>
      <path fill='#CAD1D8' d='M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z' />
      <path
        fill='#FFFFFF'
        d='M319.4,339.6c0-24.7,15.5-45.9,44.9-45.9c11.1,0,20,3.3,29.3,11.4c3.5,3.2,3.8,8.8,0.4,12.4 c-3.5,3.1-8.7,2.7-11.8-0.4c-5.2-5.5-10.6-7-17.9-7c-19.7,0-29.2,14-29.2,29.6c0,15.9,9.3,30.4,29.2,30.4c7.3,0,14.1-2.9,20-8.2 c4-3.1,9.5-1.5,11.8,1.5c2,2.8,3.1,7.6-1.4,12c-9,8.3-19.7,10-30.3,10C333.3,385.4,319.4,364.3,319.4,339.6z'
      />
    </svg>
  );
});

export default React.memo(Icon);
